module.exports = __webpack_public_path__ + "images/emoji/clock5.145148daa9e6db326278.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock5.png
// module id = nhoi
// module chunks = 1